<div class="search-bar"
    [class.has-input]="input !== ''"
    (click)="onClick()"
    (focusout)="onBlur()">
  <input placeholder="{{'table.filter' | translate}}"
         [(ngModel)]="input"
         (ngModelChange)="onInputChange($event)">
  <i class="fa fa-search" (click)="onSearch(input)"></i>
</div>